import Breadcrumb from 'component/breadcrumb/breadcrumb'
import { MarketPlaceDetailProvider } from 'context/marketplace/market-place-detail-provider'

import Information from './information'
import MarketPlaceTransaction from './transaction'

import './style.scss'

export default function MarketplaceDetails() {
  const additionalItems = [{ title: 'Marketplace', href: '/marketplace' }, { title: 'Details' }]

  return (
    <div className="p2p-create">
      <Breadcrumb additionalItems={additionalItems} />
      <MarketPlaceDetailProvider>
        <Information />
        <MarketPlaceTransaction />
      </MarketPlaceDetailProvider>
    </div>
  )
}
